import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "./context/SiteContext";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import SiteLayout from "./components/site/SiteLayout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Work from "./pages/Work";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import BlankApparel from "./pages/BlankApparel";
import Policies from "./pages/Policies";
import Quote from "./pages/Quote";
import Order from "./pages/Order";
import Checkout from "./pages/Checkout";
import ThankYou from "./pages/ThankYou";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import Submissions from "./admin/Submissions";
import ServicesAdmin from "./admin/ServicesAdmin";
import PricingAdmin from "./admin/PricingAdmin";
import GalleryAdmin from "./admin/GalleryAdmin";
import SettingsAdmin from "./admin/SettingsAdmin";
import ProductsAdmin from "./admin/ProductsAdmin";
import Designer from "./pages/Designer";
import GangSheet from "./pages/GangSheet";

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/work" element={<Work />} />
                <Route path="/about" element={<About />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/blank-apparel" element={<BlankApparel />} />
                <Route path="/policies" element={<Policies />} />
                <Route path="/quote" element={<Quote />} />
                <Route path="/order" element={<Order />} />
                <Route path="/design" element={<Designer />} />
                <Route path="/gang-sheet" element={<GangSheet />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/thank-you" element={<ThankYou />} />
              </Route>
              <Route path="/admin/*" element={<AuthProvider><AdminRoutes /></AuthProvider>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
        </CartProvider>
      </SiteProvider>
    </div>
  );
}

const AdminRoutes = () => (
  <Routes>
    <Route path="login" element={<AdminLogin />} />
    <Route element={<AdminLayout />}>
      <Route index element={<Submissions />} />
      <Route path="services" element={<ServicesAdmin />} />
      <Route path="products" element={<ProductsAdmin />} />
      <Route path="pricing" element={<PricingAdmin />} />
      <Route path="gallery" element={<GalleryAdmin />} />
      <Route path="settings" element={<SettingsAdmin />} />
    </Route>
  </Routes>
);

export default App;
